import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useProjectDocuments} from '../../../../entities';

interface DeleteProjectDocumentModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  documentId: string | null;
  onSuccess?: () => void;
}

export const DeleteProjectDocumentModal = ({open, setOpen, documentId, onSuccess}: DeleteProjectDocumentModalProps) => {
  const {deleteProjectDocumentMutation} = useProjectDocuments();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление документа',
  });

  useEffect(() => {
    if (deleteProjectDocumentMutation.error) {
      handleError(deleteProjectDocumentMutation.error as unknown as ApiError);
    }
  }, [deleteProjectDocumentMutation.error, handleError]);

  const handleSubmit = () => {
    if (documentId) {
      deleteProjectDocumentMutation.mutate(documentId, {
        onSuccess: () => {
          setOpen(false);
          if (onSuccess) {
            onSuccess();
          }
        },
      });
    }
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteProjectDocumentMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление документа'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить этот документ? Обратите внимание, что это действие безвозвратное.
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};

